import type { MediaLightboxItemReference } from '../MediaLightboxStore.types';
import { useMediaLightboxStore } from '../useMediaLightboxStore';

type UseMediaLightboxCurrentItemReference = () => MediaLightboxItemReference | undefined;
export const useMediaLightboxCurrentItemReference: UseMediaLightboxCurrentItemReference = () =>
  useMediaLightboxStore((state) => state.instance?.currentItem);

type UseMediaLightboxMessageId = () => string | undefined;
export const useMediaLightboxMessageId: UseMediaLightboxMessageId = () =>
  useMediaLightboxStore((state) => state.instance?.messageId);

type UseIsMediaLightboxOpen = () => boolean;
export const useIsMediaLightboxOpen: UseIsMediaLightboxOpen = () =>
  useMediaLightboxStore((state) => state.instance != null);

type UseHideLightboxCallback = () => () => void;
export const useHideLightboxCallback: UseHideLightboxCallback = () => useMediaLightboxStore((state) => state.hide);

type UseShowLightboxCallback = () => (currentItem: MediaLightboxItemReference, messageId?: string) => void;
export const useShowLightboxCallback: UseShowLightboxCallback = () => useMediaLightboxStore((state) => state.show);
